import React, { useState, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Button, Dialog, DialogContent, DialogActions, Divider } from '@material-ui/core';

// Services
import { deleteGroup } from 'services/requests';

// Components
import Spinner from 'components/spinner';

// --------------------------------------------------------------------------------------------------- \\
// ------------------------------------------ DELETE GROUP ------------------------------------------- \\
// --------------------------------------------------------------------------------------------------- \\

export default function DeleteGroup({ group, onClose }) {
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();
    const match = useRouteMatch();
    const [loading, setLoading] = useState(false);

    // Params
    const groupId = match.params.groupId;
    const backUrl = match.path.split('/:groupId')[0];

    useEffect(() => {
        if (loading) {
            deleteGroup(groupId).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    history.push(backUrl);
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setLoading(false);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    return (
        <Dialog open>
            {loading ? (
                <Spinner />
            ) : (
                <>
                    <DialogContent style={{ paddingBottom: 20 }}>
                        <p className="dialog-title">
                            {group.name}
                        </p>
                        Êtes-vous sûr de vouloir supprimer ce groupe ?
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Button onClick={onClose} variant="contained">
                            Non
                        </Button>
                        <Button onClick={() => setLoading(true)} variant="contained">
                            Oui
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}
